module.exports = __webpack_public_path__ + "img/no-pic.b20449df.png";